import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { DashboardRange, DashboardTilesDto } from '@/types/dashboard'

interface GetTilesOptions {
  /** Narrows the bundle to one campaign. Omit for the workspace-level dashboard. */
  campaignId?: string
  limit?: number
  mock?: boolean
}

export const dashboardApi = {
  /**
   * Every dashboard tile in one call.
   *
   * Both scopes are the same handler server-side — the campaign route only adds a segment — so
   * there is one function here rather than a workspace and a campaign variant.
   */
  getTiles: (
    workspaceId: string,
    range: DashboardRange,
    { campaignId, limit, mock }: GetTilesOptions = {},
  ): Promise<ApiResponse<DashboardTilesDto>> => {
    const scope = campaignId
      ? `${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}`
      : encodeURIComponent(workspaceId)

    const query = new URLSearchParams()
    if (limit) query.set('limit', String(limit))
    if (mock) query.set('useMock', 'true')

    const suffix = query.toString() ? `?${query.toString()}` : ''
    return apiClient.get(`/api/Dashboards/${scope}/Tiles/${encodeURIComponent(range)}${suffix}`)
  },
}
